module.exports = __webpack_public_path__ + "img/SKMJ_cap6.15744c20.jpg";